import styled from '@mui/material/styles/styled'
import Typography from '@mui/material/Typography'

export const TypographyDateTime = styled(Typography, {
  name: 'TypographyDateTime',
  slot: 'Root',
  skipSx: true,
})`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`
